module.exports = __webpack_public_path__ + "static/img/1.dce8e24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/1.png
// module id = 9uoQ
// module chunks = 0